import { useEffect, useState } from 'react'

import { RISK_LEVELS, getModelPortfoliosJsonUrl } from './libs'
import { intlNumberformatPolyfill } from '../../../../utils/intlNumberformatPolyfill'
import { ModelPortfolio } from '../../../../types/ModelPortfolio'

export function useModelPortfolios() {
  const [modelPortfolios, setModelPortfolios] = useState<ModelPortfolio[]>([])
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [error, setError] = useState<Error>()

  useEffect(() => {
    async function getModelPortfolios() {
      try {
        await intlNumberformatPolyfill()

        const data: ModelPortfolio[] = await(
          await fetch(getModelPortfoliosJsonUrl())
        ).json()

        const allowedModelPortfolios = data.filter(x =>
          RISK_LEVELS.includes(x.riskLevel)
        )

        setModelPortfolios(allowedModelPortfolios)
      } catch (e) {
        setError(e as Error)
      } finally {
        setIsLoaded(true)
      }
    }

    getModelPortfolios()
  }, [])

  return {
    modelPortfolios,
    isLoaded,
    error,
  }
}
